import { COMPETENCY_LEVEL } from 'domain/shared/newVacancy';
import type { SourcingCompetencyLevel, SourcingFilterKey } from '../../types';

export const SOURCING_FILTERS = {
  stricts: 'stricts',
  specialization: 'specializationId',
  technology: 'technologyId',
  levels: 'levels',
  location: 'location',
  englishLevel: 'englishLevel',
  skills: 'skills',
  tags: 'tags',
  lastInteraction: 'lastInteraction',
} as const;

export const SOURCING_FILTER_KEYS: SourcingFilterKey[] = [
  SOURCING_FILTERS.specialization,
  SOURCING_FILTERS.technology,
  SOURCING_FILTERS.levels,
  SOURCING_FILTERS.skills,
  SOURCING_FILTERS.englishLevel,
  SOURCING_FILTERS.location,
  SOURCING_FILTERS.tags,
  SOURCING_FILTERS.lastInteraction,
];

export const SOURCING_FILTER_LABELS: Record<SourcingFilterKey, string> = {
  [SOURCING_FILTERS.specialization]: 'Specialization',
  [SOURCING_FILTERS.technology]: 'Technology',
  [SOURCING_FILTERS.levels]: 'Levels',
  [SOURCING_FILTERS.skills]: 'Skills',
  [SOURCING_FILTERS.englishLevel]: 'Min English level',
  [SOURCING_FILTERS.location]: 'Location',
  [SOURCING_FILTERS.tags]: 'Tags',
  [SOURCING_FILTERS.lastInteraction]: 'Last interaction',
};

export const SUPPORTED_COMPETENCY_LEVELS = Object.keys({ L0: 'L0', ...COMPETENCY_LEVEL }) as SourcingCompetencyLevel[];
